import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AppContext from '../context/appContext';

const EditSubHeader = () => {
  const { id } = useParams();
  const { getAdminMe, getCustomHeaders, getSubHeaderById, updateSubHeader, deleteSubHeader } = useContext(AppContext);
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [subHeaderName, setSubHeaderName] = useState('');
  const [headers, setHeaders] = useState([]);
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);
  const [header, setHeader] = useState(null);
  const didInitRef = useRef(false);
  const history = useHistory();

  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;
    (async () => {
      const m = await getAdminMe();
      setMe(m || null);
      const list = await getCustomHeaders();
      setHeaders(Array.isArray(list) ? list : []);
      const item = await getSubHeaderById(id);
      if (item?._id) {
        setSubHeaderName(item.subHeaderName || '');
        setHeader(item.header || null);
      }
      setLoading(false);
    })();
  }, [id, getAdminMe, getCustomHeaders, getSubHeaderById]);

  const onSearch = (q) => {
    setSearch(q);
    if (!q.trim()) return setResults([]);
    const filtered = (headers || []).filter(h => (h.headerName || '').toLowerCase().includes(q.toLowerCase())).slice(0, 7);
    setResults(filtered);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!header?._id || !subHeaderName.trim()) return;
    try{
      setSaving(true);
      const updated = await updateSubHeader(id, { subHeaderName: subHeaderName.trim(), header: header._id });
      if (updated?._id) history.push('/dashboard/sub-headers');
    } finally {
      setSaving(false);
    }
  };

  const onDelete = async () => {
    if (!window.confirm('Delete this sub header?')) return;
    try{
      setDeleting(true);
      await deleteSubHeader(id);
      history.push('/dashboard/sub-headers');
    } finally {
      setDeleting(false);
    }
  };

  if (loading) return <div className="py-5 text-center"><div style={{ width: '60px', height: '60px' }} className="spinner-border " role="status"><span className="visually-hidden">Loading...</span></div></div>;

  const canEdit = !(me && (typeof me.editRole==='boolean') && me.editRole===false);

  return (
    <div className="container py-3">
      <h1 className="display-6">Edit Sub Header</h1>
      <form onSubmit={onSubmit}>
        <h5 className="mt-3">Sub Header Name</h5>
        <input disabled={!canEdit} value={subHeaderName} onChange={(e)=>setSubHeaderName(e.target.value)} className="form-control" placeholder="e.g., Generator Fuel" />
        <h5 className="mt-3">Header</h5>
        {!header && (
          <>
            <input disabled={!canEdit} value={search} onChange={(e)=>onSearch(e.target.value)} className="form-control" placeholder="Search header..." />
            {search.trim() && results.length>0 && (
              <ul className="list-group my-2">
                {results.map(h => (
                  <li key={h._id} className="list-group-item" style={{cursor: canEdit ? 'pointer' : 'not-allowed', opacity: canEdit ? 1 : .5}} onClick={()=>{ if(!canEdit) return; setHeader(h); setSearch(''); setResults([]); }}>
                    {h.headerName}
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
        {header && (
          <div className="list-group my-2">
            <div className="list-group-item active d-flex justify-content-between align-items-center">
              <span>{header.headerName}</span>
              <button type="button" className="btn-close" onClick={()=>{ if(!canEdit) return; setHeader(null); }} />
            </div>
          </div>
        )}
        <div className="d-flex justify-content-between mt-3">
          <button type="button" disabled={deleting || !canEdit} onClick={onDelete} className="btn btn-danger">{deleting ? <span className="spinner-border spinner-border-sm"></span> : 'Delete'}</button>
          <button disabled={saving || !canEdit} className="btn btn-outline-primary">{saving ? <span className="spinner-border spinner-border-sm"></span> : 'Save Changes'}</button>
        </div>
      </form>
    </div>
  );
};

export default EditSubHeader;


